import React from 'react';

import Banner from '../../../components/BannerDefault';
import CadastroForm from '../../../components/Forms/CadastroDefault';

import style from './cadastro.module.scss';

export default function Cadastro() {
  return (
    <Banner
      image={{ src: '/img/fundohistsobrenos.webp' }}
      width='100%'
      height='fit-content'>
      <div className={style.cadastroForm}>
        <CadastroForm />
      </div>
    </Banner>
  );
}
